export default () => {
  return {
    id: {
      prop: 'id',
      label: '编号',
      value: ''
    },
    businessName: {
      prop: 'businessName',
      label: '业务区',
      value: '',
      values: [],
      arg: 0,
      type: 'select'
    },
    projectName: {
      label: '项目名称',
      prop: 'projectName',
      value: '',
      type: 'text'
    },
    businessType: {
      prop: 'businessType',
      label: '业务类型',
      value: '',
      values: [],
      arg: 6,
      type: 'select'
    },
    progressStatus: {
      label: '进度状态',
      prop: 'progressStatus',
      value: '',
      values: [],
      arg: 3,
      type: 'select'
    },
    budget: {
      label: '预算',
      prop: 'budget',
      value: 80,
      type: 'number'
    },
    projectManagerA: {
      label: '项目经理A',
      prop: 'projectManagerA',
      value: '',
      values: [],
      arg: 0,
      type: 'select'
    },
    projectManagerB: {
      label: '项目经理B',
      prop: 'projectManagerB',
      value: '',
      values: [],
      arg: 0,
      type: 'select'
    },
    integrators: {
      label: '集成商',
      prop: 'integrators',
      value: '',
      values: [],
      arg: 1,
      type: 'select'
    },
    projectType: {
      label: '项目类型',
      prop: 'projectType',
      value: '',
      values: [],
      arg: 5,
      type: 'select'
    },
    startDate: {
      label: '启动时间',
      prop: 'startDate',
      value: '',
      type: 'date'
    },
    reachExpect: {
      label: '达产预期',
      prop: 'reachExpect',
      value: '',
      values: [],
      arg: 2,
      type: 'select'
    },
    nextAction: {
      label: '下步动作',
      prop: 'nextAction',
      value: '',
      type: 'textarea',
      rows: 3
    },
    nextDeadline: {
      label: '下步期限',
      prop: 'nextDeadline',
      value: '',
      type: 'date'
    },
    clientManager: {
      label: '客户经理',
      prop: 'clientManager',
      value: '',
      values: [],
      arg: 0,
      type: 'select'
    },
    jobsDescription: {
      label: '支撑工作描述（加时间点）',
      prop: 'jobsDescription',
      value: '',
      type: 'textarea',
      rows: 8
    },
    forexAnalysis: {
      label: '复盘分析',
      prop: 'forexAnalysis',
      value: '',
      type: 'text'
    },
    evaluate: {
      label: '业务区评价',
      prop: 'evaluate',
      value: '',
      type: 'text'
    },
    projectDescription: {
      label: '项目描述',
      prop: 'projectDescription',
      value: '',
      type: 'textarea',
      rows: 8
    },
    remark: {
      label: '备注',
      prop: 'remark',
      value: '',
      type: 'textarea',
      rows: 4
    }
  };
};
